import { Dentist2D } from "@/components/Dentist2D";
import { DentistButton } from "@/components/DentistButton";
import ReactLenis from "lenis/react";

export function DentistPage() {
  return (
    <>
      <ReactLenis root />
      <div className="relative text-white flex flex-col items-center justify-center min-h-screen">
        <div className="fixed top-0 left-0 w-screen h-screen -z-10">
          <Dentist2D />
        </div>
        <div className="h-[750vh]"></div>
          <DentistButton />
      </div>
    </>
  );
}
